/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Application from 'src/front/components/Application';

import { StepperRefProps } from 'src/front/components/StepperView';

import CardReissueProvider from 'src/front/contexts/CardReissueContext';
import CardReissueCardSearch from './CardReissueCardSearch';
import CardReissueCustomerSearch from './CardReissueCustomerSearch';
import CardReissueIssue from './CardReissueIssue';

const CardReissue: FC = () => {
  const { t } = useTranslation();

  const stepperRef = useRef<StepperRefProps>(null);

  const [showLastStep, setShowLastStep] = useState<boolean>(true);
  const [isCompleted, setIsCompleted] = useState<boolean>(false);
  const [showIncomeLabels, setShowIncomeLabels] = useState<boolean>(false);
  const goToNextStep = (): void => stepperRef.current?.goToNextStep();

  const goToFirstStep = (): void => stepperRef.current?.goToFirstStep();

  const steps = useMemo(() => {
    return [
      {
        component: () => <CardReissueCustomerSearch goToNextStep={goToNextStep} />,
      },
      {
        component: () => (
          <CardReissueCardSearch
            goToFirstStep={goToFirstStep}
            goToNextStep={goToNextStep}
            setShowIncomeLabels={setShowIncomeLabels}
            setShowLastStep={setShowLastStep}
          />
        ),
      },
      ...(showLastStep
        ? [
            {
              component: () => (
                <CardReissueIssue
                  goToFirstStep={goToFirstStep}
                  setIsCompleted={setIsCompleted}
                  showIncomeLabels={showIncomeLabels}
                />
              ),
            },
          ]
        : []),
    ];
  }, [showIncomeLabels, showLastStep]);

  const stepsVertical = useMemo(() => {
    const stepDefinitions = [
      {
        text: t('cardReissue_stepper_clientSearch_text'),
      },
      {
        text: t('cardReissue_stepper_cardSearch_text'),
      },
      ...(showLastStep
        ? [
            {
              text: t('cardReissue_stepper_cardReissue_text'),
            },
          ]
        : []),
    ];

    return stepDefinitions.map((item, index) => ({
      text: item.text,
      index: index + 1,
    }));
  }, [showLastStep, t]);

  return (
    <CardReissueProvider>
      <Application
        isCompleted={isCompleted}
        stepperRef={stepperRef}
        steps={steps}
        stepsVertical={stepsVertical}
      />
    </CardReissueProvider>
  );
};

export default CardReissue;
